import type { MarketGroupsApi } from "@/v2/api/metadata/market-groups";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { notify, notifyApiError } from "@/v2/notifications/notify";
import { NXGDSStatusVariant } from "@nsftx/seven-nxg-design-system-backoffice";

export function createDeleteDialog(options: { marketGroupsApi: MarketGroupsApi }): DialogConfig {
  const { marketGroupsApi } = options;

  return {
    id: "delete-market-group",
    title: "Delete market group",
    description: "Are you sure you want to delete this market group?",
    layout: {
      type: "nxgds-dialog",
      actions: [
        { intent: "dismiss", label: "Cancel", variant: "secondary" },
        { intent: "submit", label: "Delete", variant: "danger" },
      ],
    },
    structure: { type: "flat", children: [] },
    api: {
      submit: async (_data, dialogCtx) => {
        try {
          await marketGroupsApi.delete(dialogCtx.row?.id);
          notify({
            variant: NXGDSStatusVariant.Positive,
            text: `You have successfully deleted "${dialogCtx.row?.name}" market group.`,
          });
        } catch (error) {
          notifyApiError(error, `Unable to delete "${dialogCtx.row?.name}" market group.`);
        }
      },
    },
  };
}
